'use strict';

import React from 'react';

import $style from './style';

module.exports = React.createClass({

    _targetSwitch: null,

    componentWillUnmount() {

        clearInterval(this._targetSwitch);
        $style.unuse();
    },

    nextItem() {

        this.setState({
            teardown: true
        });

        setTimeout(() => {
            this.setState({
                index: ((this.props.itens.length - 1) != this.state.index)
                    ? this.state.index + 1 : 0
            });
        }, 400);

        setTimeout(() => {
            this.setState({
                teardown: false
            });
        }, 500);
    },

    componentDidMount() {

        this._targetSwitch = setInterval(this.nextItem, this.props.timeout || 5000);
    },

    componentWillMount() {

        $style.use();
    },

    getInitialState() {

        return {
            index: 0,
            teardown: false
        };
    },

	render: function() {

        let s = this.state;
        let itens = this.props.itens;

        return (
            <div className={ "dynamic " + (s.teardown ? 'fadeout':'' ) } index={s.index}>
                {itens[s.index]}
            </div>
        );
	}
})



// WEBPACK FOOTER //
// ./ui/gui/components/dynamic/index.js